import ShortenedTitle from "components/General-UI/ShortenedTitle";
import Spinner from "components/General-UI/Spinner";
import CopyButton from "components/Home/ui/CopyButton";
import { INVITE_LINK_START_V01 } from "constants/constants";
import React, { useEffect, useState } from "react";
import {
  createInviteCode,
  deleteInviteCode,
  getInviteCode,
} from "slices/peopleSlice";

const RoomLinkMain = ({ node: { id, content } }) => {
  const [code, setCode] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getInviteCode(id)
      .then((link) => setCode(link))
      .finally(() => setLoaded(true));
  }, [id]);

  return (
    <div className="invite-people-main">
      <p className="no-select">
        {code ? (
          <>
            <span className="font-extra-bold">Anyone</span> with this link can
            enter "
            <ShortenedTitle maxChars={50} title={content} />" right now. Room
            links can be disabled anytime.
          </>
        ) : (
          <>
            <span className="font-extra-bold">Only members</span> can enter "
            <ShortenedTitle maxChars={50} title={content} />" right now. Make a
            room link to invite guests.{" "}
          </>
        )}
      </p>
      <div className="link-share-row">
        {/* <div className="link-share-title">Effice Invite Link:</div> */}
        {!loaded ? (
          <Spinner bgDark={false} spinnerLight={false} immediateShow={false} />
        ) : (
          <>
            {code ? (
              <>
                <div className="link-font">{`${INVITE_LINK_START_V01}${code}`}</div>
                <div className="effice-link-buttons">
                  <CopyButton textToCopy={`${INVITE_LINK_START_V01}${code}`} />
                  <span
                    className="invite-delete"
                    onClick={async () => {
                      setLoaded(false);
                      await deleteInviteCode(id).then(() => setCode(null));
                      setLoaded(true);
                    }}
                  >
                    disable
                  </span>
                </div>
              </>
            ) : (
              <div
                className="confirm-button growth-button get-effice-link"
                onClick={async () => {
                  setLoaded(false);
                  await createInviteCode(id, 24 * 365).then((link) => {
                    setCode(link);
                  });
                  setLoaded(true);
                }}
              >
                Make Effice Invite Link
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RoomLinkMain;
